import { PEEL_STICK_ITEM_TYPE } from 'app/constants/product'

export default function productIsSwatch (item = {}) {
  return item.itemType === PEEL_STICK_ITEM_TYPE
}
